// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3802":"a898e71d","9956":"52de84cc"}[chunkId] + ".chunk.css";
};